import { render, staticRenderFns } from "./mb-status-select.vue?vue&type=template&id=1e0097bd&scoped=true&"
import script from "./mb-status-select.vue?vue&type=script&lang=ts&"
export * from "./mb-status-select.vue?vue&type=script&lang=ts&"
import style0 from "./mb-status-select.vue?vue&type=style&index=0&id=1e0097bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0097bd",
  null
  
)

export default component.exports